/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EconomicDetailResource { 
    key: string;
    value: string;
    type: string;
    isBold: boolean;
}

